module.exports = __webpack_public_path__ + "media/custom/images/pocstock-contributor-collage-2-1b58001044e6593737d08fb795f3e3d1.png";